// extracted by mini-css-extract-plugin
module.exports = {"nav":"explore_nav__3yNV0"};